<template>
  <div class="flex w-full justify-center px-24">
    <div class="flex w-full items-center justify-center py-4" v-if="isLoading">
      <i v-html="$icons.loading"></i>
    </div>
    <div class="border-ontick-carbon-500 w-full rounded border px-6 py-4" v-else>
      <div class="divide-ontick-steel-500 flex flex-col divide-y uppercase text-gray-500 dark:text-gray-400">
        <div class="flex w-full flex-col gap-4 pb-4">
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Par</p>
            </div>
            <div class="data-col gap-2">
              <div class="order-type">
                {{ orderType(symbols.symbol_1.order_type) }}
              </div>
              <span>
                {{ symbols.symbol_1.symbol_name }}
              </span>
            </div>
            <div class="data-col gap-2">
              <div class="order-type">
                {{ orderType(symbols.symbol_2.order_type) }}
              </div>
              <span>
                {{ symbols.symbol_2.symbol_name }}
              </span>
            </div>
          </div>
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Volume</p>
            </div>
            <template v-if="volumeIsEditable">
              <!-- <input
                type="text"
                class="bg-ontick-carbon-500 col-span-2 w-full rounded border-0 text-right text-xs shadow"
                v-money="money"
                :value="editableVolume"
                @input="$emit('edit-volume', $event.target.value)"
              /> -->
              <ontick-editable-select-component
                :options="volumeOptions"
                :value="editableVolume"
                :acceptInput="false"
                currency
                name="editableVolume"
                label=""
                @input="$emit('edit-volume', $event.value)"
              />
            </template>
            <template v-else>
              <div class="data-col gap-2">
                {{ symbols.symbol_1.total_volume }}
              </div>
              <div class="data-col gap-2">
                {{ symbols.symbol_2.total_volume }}
              </div>
            </template>
          </div>
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Preço</p>
            </div>
            <div class="data-col gap-2" v-if="symbolsInfo.symbol_1_info">
              {{ symbolsInfo.symbol_1_info.symbol_1_close | currency }}
            </div>
            <div class="data-col gap-2" v-if="symbolsInfo.symbol_2_info">
              {{ symbolsInfo.symbol_2_info.symbol_2_close | currency }}
            </div>
          </div>
        </div>
        <div class="flex w-full flex-col gap-4 pt-4">
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Tipo</p>
            </div>

            <div class="data-col text-ontick-yellow-700 gap-2 font-semibold">
              <span>
                {{ direction(info.alg_ord_direction) }}
              </span>
            </div>
          </div>
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Método</p>
            </div>
            <div class="data-col gap-2">
              {{ method(info.alg_ord_calc_type) }}
            </div>
          </div>
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Entrada</p>
            </div>

            <div class="data-col gap-2">
              {{ info.alg_ord_entry || "Indefinido" }}
            </div>
          </div>
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Take profit</p>
            </div>
            <div class="data-col gap-2">
              {{ info.alg_ord_tp || "Indefinido" }}
            </div>
          </div>
          <div class="data-row">
            <div class="data-col">
              <p class="font-semibold text-gray-500 dark:text-gray-300">Stop Loss</p>
            </div>
            <div class="data-col gap-2">
              {{ info.alg_ord_sl || "Indefinido" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VMoney } from "v-money";
import ontickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";

export default {
  components: {
    ontickEditableSelectComponent,
  },

  directives: {
    money: VMoney,
  },

  props: {
    symbols: {
      type: Object,
    },
    info: {
      type: Object,
    },
    volumeIsEditable: {
      type: Boolean,
    },
    editableVolume: {
      type: [Number, String],
    },
  },

  data() {
    return {
      symbolsInfo: {},
      isLoading: false,
    };
  },

  computed: {
    volumeOptions() {
      let arr = [];
      for (let i = 0; i < 20; i++) {
        arr.push({
          label: String((i + 1) * 25000),
          value: (i + 1) * 25000,
        });
      }
      return arr;
    },
  },

  methods: {
    direction(alg_ord_direction) {
      switch (alg_ord_direction) {
        case "BUY":
          return "Compra";
        case "SELL":
          return "Venda";
        default:
          return alg_ord_direction;
      }
    },
    method(alg_ord_calc_type) {
      switch (alg_ord_calc_type) {
        case "FACTOR":
          return "Fator";
        case "DIFFERENCE":
          return "Diferença";
        case "LINEAR_FUNCTION":
          return "Função linear";
        default:
          return alg_ord_calc_type;
      }
    },
    orderType(order_type) {
      switch (order_type) {
        case "BUY":
          return "C";
        case "SELL":
          return "V";
      }
    },
    getSymbolPrices(symbol_1, symbol_2) {
      return this.$api
        .get(this.$endpoint.CHECK_ALGO_ORDER_SYMBOLS, {
          params: {
            symbol_1,
            symbol_2,
          },
        })
        .then((res) => {
          // console.log(res);
          this.symbolsInfo = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },

  async mounted() {
    this.isLoading = true;
    const symbol_1 = await this.symbols?.symbol_1.symbol_name;
    const symbol_2 = await this.symbols?.symbol_2.symbol_name;
    this.getSymbolPrices(symbol_1, symbol_2).finally(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.order-type {
  @apply bg-ontick-teal-600 text-ontick-teal-50 flex h-5 min-w-[20px] items-center justify-center rounded text-[10px];
}
.data-row {
  @apply grid auto-cols-fr grid-flow-col;
  .data-col {
    @apply flex items-center justify-center first:justify-start last:justify-end;
  }
}
</style>
